import { UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import { AdvantageItem } from './components/AdvantageItem';
import * as styles from './styles.css';
import { IAdvantage } from '../../types/newobject/newbuildingAdvantages';
import { VerticalSliderFullscreen } from '../VerticalSlider';

interface IAdvantagesProps {
  advantages: IAdvantage[];
  onItemClick(i: number): void;
}

export function Advantages({ advantages, onItemClick }: IAdvantagesProps) {
  return (
    <div className={styles['advantages']}>
      <div className={styles['header']}>
        <UIHeading1 as="h1" fontWeight="bold">
          Особенности жилого комплекса
        </UIHeading1>
      </div>
      <div className={styles['container']}>
        <VerticalSliderFullscreen onItemClick={onItemClick}>
          {advantages.map(({ title, images }) => (
            <AdvantageItem key={title} title={title} imgUrl={images[0]?.url} counter={images.length} />
          ))}
        </VerticalSliderFullscreen>
      </div>
    </div>
  );
}
